import { db } from "@/firebaseConfig";
const printerHistoryCollection = db.collection("printer_history");

const savePrinterHistory = async data => {
  printerHistoryCollection
    .doc()
    .set(data)
    .then(() => {
      console.log("PrinterHistory successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const updatePrinterHistory = async (id, data) => {
  printerHistoryCollection
    .doc(id)
    .update(data)
    .then(() => {
      console.log("PrinterHistory successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const deletePrinterHistory = async id => {
  printerHistoryCollection
    .doc(id)
    .delete()
    .then(() => {
      console.log("PrinterHistory successfully written!");
    })
    .catch(error => {
      throw error;
    });
};

const getPrinterHistoryById = async id => {
  return printerHistoryCollection
    .doc(id)
    .get()
    .then(doc => {
      return doc.exists ? doc.data() : null;
    })
    .catch(error => {
      throw error;
    });
};

const getPrinterHisotryByDateRange = async (date1, date2) => {
  return printerHistoryCollection
    .where("time", ">=", date1)
    .where("time", "<=", date2)
    .orderBy("time", "desc")
    .get()
    .then(querySnapshot => {
      let result = [];

      querySnapshot.forEach(doc => {
        result.push({ id: doc.id, ...doc.data() });
      });

      return result;
    })
    .catch(error => {
      throw error;
    });
};

export {
  printerHistoryCollection,
  savePrinterHistory,
  updatePrinterHistory,
  deletePrinterHistory,
  getPrinterHistoryById,
  getPrinterHisotryByDateRange
};
